import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--sale);
  color: white;
  padding: 10px 16px;
  min-height: 28px;
  box-sizing: border-box;
  text-align: center;
  font-weight: var(--font-regular);
  font-size: 15px;
  line-height: 1.1;

  a {
    color: white;
    text-decoration: none;
    font-weight: var(--font-medium);
  }
  strong {
    font-weight: var(--font-bold);
  }

  @media (max-width: 767px) {
    padding: 8px 16px;
  }
`
export const MobileContent = styled.div`
  display: none;
  font-size: 13px;

  @media (max-width: 767px) {
    display: block;
  }
`
export const DesktopContent = styled.div<{ responsive: boolean }>`
  display: block;

  @media (max-width: 767px) {
    font-size: 12px;

    ${({ responsive }) =>
      !responsive &&
      `
      display: none;
    `}
  }
`
